import cloneDeep from 'lodash-es/cloneDeep';
import mergeWith from 'lodash-es/mergeWith';
import isArray from 'lodash-es/isArray';

export const StepMixin = {
  props: {
    box: {
      type: Object,
      require: true,
      default: () => ({})
    },

    /**
     * Начальное состояние, чтобы при нажатии кнопки "Сохранить",
     * не обновлялся заголовок блока
     */
    box_init: {
      type: Object,
      require: true,
      default: () => ({})
    },

    step: {
      type: String,
      default: 'init'
    }
  },

  data() {
    return {
      form: {
        name: '',
        params: {}
      }
    };
  },

  watch: {
    box: {
      /**
       * Форма состоит только из name и данных из params
       */
      handler: function(box) {
        const clone = cloneDeep(box);
        this.form = { name: clone.name, params: clone.data.params || {} };
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    /**
     * Используется как кнопка "Назад", без сохранения инфы о шаге
     */
    mixin_set_init_step: function() {
      this.mixin_set_step('init');
    },

    mixin_set_step(step, params = {}) {
      this.$emit('change-step', { step, params });
    },

    /**
     * Получаем объект перед отправкой на сервер
     */
    mixin_get_box(data) {
      return mergeWith(
        this.box,
        {
          name: data.name,
          data: { params: data.params }
        },
        (source_value, merged_value) => {
          /**
           * merge по-умолчанию склеивает объекты и массивы в один, если сможет.
           * К примеру:
           *  var object = { 'a': [1], 'b': [2] };
           *  var other = { 'a': [3], 'b': [4] };
           *  mergeWith(object, other, customizer); => { 'a': [1, 3], 'b': [2, 4] }
           *
           *  А нам нужно оставить только новое значение для массивов.
           *  Чтобы при удалении записи (к примеру списка контактов)
           */
          if (isArray(source_value)) {
            return merged_value;
          }
        }
      );
    },

    /**
     * Сохраняем состояние формы между шагами
     * @param data
     */
    mixin_save_step(data) {
      const merge = this.mixin_get_box(data);
      this.$emit('update:box', merge);
    },

    mixin_set_param(key, value) {
      this.form = {
        ...this.form,
        params: {
          ...this.form.params,
          [key]: value
        }
      };
    }
  }
};
